<app-browser-detect></app-browser-detect>

<header class="main-header d-flex justify-content-between align-items-center">
  <div style="width:20%">
    <a href="/plan/{{plan?.id}}/5" routerLink="/plan/{{plan?.id}}/5" class="btn">
      <b><i class="bi bi-arrow-left-short"></i></b>
    </a>
  </div>

  <b>
    <span class="color-grey">Gestion des cartes</span> : {{_type | replace: '_' : ' '}}
  </b>

  <div style="width:20%" class="d-flex justify-content-end"></div>
</header>

<div class="page-map">
  <div class="page-map-panel bg-white">
    <div class="pm-panel d-flex justify-content-between flex-column h-100">
      <div class="pm-panel-content">
        <div class="m-3">

          @if (mapReady) {
            <app-collapse name="Calque du fond de carte">
              <select-map-background [map]="mapComponent"></select-map-background>
            </app-collapse>
          }

          @if (currentSnapshot.title) {
            <app-collapse name="Titre">
              <mat-form-field appearance="outline" class="w-100 mt-3">
                <mat-label>Titre du zoom</mat-label>
                <input matInput
                       [(ngModel)]="currentSnapshot.title"
                       [ngModelOptions]="{standalone: true}"
                       [maxLength]="50"
                       required
                       name="title">
              </mat-form-field>
            </app-collapse>
          }

          <layer-multi-load />

          <app-collapse name="Calques">
            <layer-control></layer-control>
          </app-collapse>
        </div>



      </div>
      <div class="pm-panel-actions text-center gap-3 p-3">
        <button class="pm-btn pm-btn-primary" [disabled]="isLoadingLayer" type="button" (click)="screenshot()">
          Generer le zoom
        </button>
      </div>
    </div>
  </div>
  <div class="page-map-content">
    @if (!!plan) {
      <app-map-cesium #map
                      [snapshot]="currentSnapshot"
                      [type]="_type"
                      [plan]="plan"
                      [canvasMode]="'3d'"
                      (isLoadingLayer)="isLoadingLayer = $event"
                      (whenMapIsInit)="mapIsInit()">
        @if (currentSnapshot.title) {
          <div class="map-title"
               id="title_position"
               [hidden]="!currentSnapshot.title"
               cdkDragBoundary=".dragBoundary"
               (cdkDragEnded)="dragEnd($event)"
               cdkDrag [cdkDragFreeDragPosition]="titleInitialPosition">
            {{currentSnapshot.title}}
          </div>
        }
      </app-map-cesium>
    }
  </div>
</div>
